export class GlobalInjector {
    static injector;
}